module.exports = "<ul class=\"kl-menu {class}\">\n  {#inc this.$body}\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLMenu/index.html
// module id = 499
// module chunks = 0